// import axios from "../../UI/CreateAxios/CreateAxios";
import React, { useState, useEffect } from "react";
import { MdClose, MdDelete, MdEdit } from "react-icons/md";
import Table from "../../UI/Table/Table";
import * as yup from "yup";
import img from "../../../Resources/images/japan.jpg";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "../../../HOC/CreateAxios/CreateAxios";
import MasterDeleteModal from "../../UI/Model/MasterDeleteModel/MasterDeleteModel";
import { Formik, Field, Form } from "formik";
function ViewBooking() {
  const [idStore, setIdStore] = useState(false);
  const [message, setMessage] = useState(false);
  const [tBody, setTBody] = useState([]);
  const [showEditData, setShowEditData] = useState(false);
  const [storeImage, setStoreImage] = useState("");
  const [ID, setID] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [serviceData, setServiceData] = useState([]);
  const Thead = [
    { title: "s.nO", width: "15%" },
    { title: "title", width: "15%" },
    { title: "price", width: "15%" },
    { title: "service", width: "15%" },
    { title: "Arriving date ", width: "15%" },
    { title: "image", width: "15%" },
    { title: "status", width: "15%" },
    { title: "action", width: "15%" },
  ];
  let TeacherImageSchema = yup.object().shape({
    title: yup.string().required("Title time Date is required"),
    price: yup.string().required("Price time is required"),
    // service: yup.string().required("Service  is required"),
    date: yup.string().required(" Date is required"),
    status: yup.string().required(" Status is required"),
    // image: yup.string().required("Image  is required"),
  });
  const getData = () => {
    axios
      .get("/booking")
      .then((res) => {
        console.log(res);
        setTBody(res?.data?.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const DeleteItems = () => {
    // console.log(idStore);
    axios
      .delete(`/booking/${idStore}`)
      .then((res) => {
        if (res.status === 200) {
          setMessage(false);
          getData(idStore);
          toast.error("Data has been deleted sucessfully");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const Conformation = (id) => {
    setMessage(true);
    setIdStore(id);
    // console.log(id);
  };
  let ConformationMessage;
  if (message) {
    ConformationMessage = (
      <MasterDeleteModal
        // id={idStore}
        Delete={DeleteItems}
        setMessage={setMessage}
      />
    );
  }
  const handleChange = (e) => {
    setStoreImage(e.target.files[0]);
  };
  const data = [
    // { id: 1, title: "accepted" },
    { id: 1, title: "pending" },
    { id: 2, title: "canceled" },
    { id: 3, title: "completed" },
  ];
  let opt = [];
  data?.map((val, i) => {
    let store = {
      id: val?.id,
      title: val?.title,
    };
    return opt.push(store);
  });
  const getService = () => {
    axios
      .get("/service")
      .then((res) => {
        console.log(res);
        setServiceData(res.data.result);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getService();
  }, []);

  let opts = [];
  serviceData?.map((val, i) => {
    console.log(val?.name);
    let store = {
      id: val?.id,
      title: val?.service_name,
    };
    return opts.push(store);
  });
  console.log(opts);
  const FormDatas = [
    { label: "title", type: "text", placeholder: "title", apikey: "title" },
    { label: "price", type: "number", placeholder: "price", apikey: "price" },
    {
      label: "service",
      type: "select",
      placeholder: "no of service",
      apikey: "service",
      options: [{ id: 0, title: "Select service" }, ...opts],
    },
    {
      label: "Arriving date",
      type: "date",

      apikey: "date",
    },
    {
      label: "status",
      type: "select",
      apikey: "status",
      options: [{ id: 0, title: "Select Status" }, ...opt],
    },
    {
      label: "image",
      type: "file",
      accept: "image/*,.jpg,.png,.jpeg,.mov",
      apikey: "image",
    },
  ];
  const Edit = (value) => {
    setShowEditData(true);
    setID([value]);
  };
  console.log(ID);

  const Submit = (value) => {
    // value.details = storeDescription;
    value.image = storeImage;
    // value.pdf = storeImage;
    // console.log(value);
    let formData = new FormData();
    formData.append("image", storeImage);
    formData.append("title", value.title);
    formData.append("date", value.date);
    formData.append("status", value.status);
    formData.append("token", value.token);
    // formData.append("service", value.service);
    // console.log(ID);
    ID[0]?.service?.map((vals, i) => {
      console.log(vals);
      return formData.append(
        "service[]",
        JSON.stringify({ id: vals.service_id, name: vals.name })
      );
    });
    formData.append("price", value.price);
    // alert("working");
    console.log(value);
    axios
      .patch(`/booking/${ID[0].id}`, formData)
      .then((res) => {
        console.log(res);
        if (res.status === 200) {
          setShowEditData(false);
          // window.location.reload();
          toast.info("Data has been updated sucessfully");
          getData(ID.id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const MultiSelect = (e, name) => {
    let data = e.target.value.split("/");
    // console.log(e.target.value, name);
    let newArray = ID;
    if ("service" === name) {
      // console.log(newArray);

      newArray[0].service = [
        ...newArray[0].service,
        { service_id: data[0], name: data[1] },
      ];
    } else {
      // newArray[0].status = [
      //   ...newArray[0].status,
      //   { id: data[0], name: data[1] },
      // ];
      newArray[0].status = newArray[0].status;
    }
    // if ("status" === name) {
    //   newArray[0].status = [
    //     ...newArray[0].status,
    //     // { id: data[0], name: data[1] },
    //   ];
    // }
    setID([...newArray]);
  };
  const RemoveMultiSelecting = (id) => {
    // console.log(id);

    let data = ID;
    data[0].service.splice(id, 1);
    setID([...data]);
  };
  // edit module popup available here
  let mod;
  mod = (
    <div
      className={` 
          absolute top-0 bottom-0 right-0 left-0  z-40 `}
    >
      <div
        className=" relative z-50 bg-[white] mt-3 rounded-md    flex 
      px-5 w-11/12 md:w-7/12 mx-auto h-fit "
      >
        <div className="w-[95%]  ">
          <ToastContainer />
          {/* {console.log(multiSelecting)}{" "} */}
          <Formik
            initialValues={{
              title: ID[0]?.title,
              price: ID[0]?.price,
              service: "",
              date: ID[0]?.date,
              image: ID[0]?.image,
              status: ID[0]?.status,
              token: ID[0]?.token,
            }}
            validationSchema={TeacherImageSchema}
            onSubmit={(values, { resetForm }) => {
              console.log(values);
              Submit(values);
              resetForm();
            }}
          >
            {({ touched, errors, setFieldValue, handleSubmit, values }) => {
              return (
                <Form className=" text-left my-3" onSubmit={handleSubmit}>
                  {FormDatas.map((val, i) => {
                    if (val.type === "file") {
                      return (
                        <div className="" key={i}>
                          <div className="capitalize font-medium text-gray-700 my-2">
                            <label>{val.label}</label>
                          </div>

                          <div
                            className={`  flex border border-gray-200 rounded-sm space-x-1 gap-3 ${
                              storeImage ? "h-72" : "h-fit"
                            }  `}
                          >
                            <div className="   m-2">
                              <label htmlFor="image">
                                <div className="  capitalize w-24 h-24 cursor-pointer p-1 flex bg-gray-100 items-center justify-center">
                                  + add
                                </div>
                              </label>
                            </div>
                            <div
                              className={`w-96   ${
                                storeImage ? "h-60" : "h-fit"
                              } mt-3`}
                            >
                              {
                                <img
                                  src={
                                    storeImage.length === 0
                                      ? `${process.env.REACT_APP_API_URL}/public/${values.image}`
                                      : URL.createObjectURL(storeImage)
                                  }
                                  alt="Loading..."
                                  className="object-cover w-60  h-60 object-top"
                                />
                              }
                            </div>
                          </div>

                          <input
                            id="image"
                            type={val.type}
                            accept={val.accept}
                            name={val.apikey}
                            onChange={(e) => handleChange(e)}
                            className="bg-white hidden relative z-50  outline-none rounded-sm
                                border-none px-2 py-1"
                          />
                          <div
                            className={`${
                              errors[val.apikey] && touched[val.apikey]
                                ? "text-red-500  my-2 p-0.5 text-sm bg-red-100"
                                : ""
                            } `}
                          >
                            {errors[val.apikey] && touched[val.apikey]
                              ? errors[val.apikey]
                              : ""}
                          </div>
                        </div>
                      );
                    } else if (val.type === "select") {
                      return (
                        <div key={i}>
                          <div className="capitalize font-medium w-full text-gray-700 my-2">
                            <label htmlFor={val.apikey}>{val.label}</label>
                          </div>
                          <Field
                            as={val.type}
                            id={val.apikey}
                            name={val.apikey}
                            className={` ${
                              val.apikey ? "focus:border-blue-800" : ""
                            } bg-white  relative z-50  outline-none placeholder:capitalize placeholder:text-sm placeholder:font-light rounded-[4px]
                            w-full   border border-gray-300 px-2 py-2`}
                            key={i}
                            onChange={(e) => {
                              val.apikey === "service"
                                ? MultiSelect(e, val.apikey)
                                : setFieldValue("status", e.target.value);
                            }}
                          >
                            {val.options
                              ? val.options.length === 0
                                ? null
                                : val?.options?.map((vals, i) => {
                                    console.log(vals);
                                    return (
                                      <option
                                        key={i}
                                        // value={val.apikey}
                                        // name={val.apikey}
                                        value={
                                          val.apikey === "service"
                                            ? vals.id + "/" + vals.title
                                            : vals.title
                                        }
                                      >
                                        {vals.title}
                                      </option>
                                    );
                                  })
                              : ""}
                          </Field>
                          <div
                            className={`${
                              ID[0]?.service?.length > 0 &&
                              val?.apikey === "service"
                                ? "bg-gray-200  tablet:absolut top-[95px]  overflow-scroll h-20 w-full mt-2 "
                                : ""
                            }`}
                          >
                            <div
                              className={`${
                                ID[0]?.service?.length > 0 &&
                                val.apikey === "service"
                                  ? "bg-gray-200 w-full p-1 mt-2"
                                  : ""
                              }`}
                            >
                              <div className=" w-fit">
                                <div className="flex flex-wrap gap-3 ">
                                  {val.apikey === "service" &&
                                    ID[0]?.service?.map((item, i) => {
                                      // console.log(item);
                                      return (
                                        <div
                                          key={i}
                                          className="
                                w-fit relative   items-center px-2 py-2"
                                        >
                                          <div className="bg-white   px-2 py-2 capitalize rounded-[3px]">
                                            {item.name}
                                            <div
                                              className="bg-red-500 cursor-pointer text-white w-fit rounded-full absolute top-0 right-0"
                                              onClick={() =>
                                                RemoveMultiSelecting(i)
                                              }
                                            >
                                              {ID[0]?.service?.length > 0 &&
                                                val?.apikey === "service" && (
                                                  <MdClose />
                                                )}
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className={`${
                              errors[val.apikey] && touched[val.apikey]
                                ? "text-red-500  my-2 p-0.5 text-sm bg-red-100"
                                : ""
                            } `}
                          >
                            {errors[val.apikey] && touched[val.apikey]
                              ? errors[val.apikey]
                              : ""}
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div className=" w-full relative" key={i}>
                          <div className="capitalize font-medium w-full text-gray-700 my-2">
                            <label htmlFor={val.apikey}>{val.label}</label>
                          </div>
                          <Field
                            id={val.apikey}
                            type={val.type}
                            name={val.apikey}
                            className={`bg-white ${
                              val.apikey ? "focus:border-blue-800" : ""
                            }  relative z-50  outline-none rounded-[4px]
                            w-full   border border-gray-300 px-2 py-2`}
                          />

                          <div
                            className={`${
                              errors[val.apikey] && touched[val.apikey]
                                ? "text-red-500 text-sm bg-red-100 my-2 px-1"
                                : ""
                            }`}
                          >
                            {errors[val.apikey] && touched[val.apikey]
                              ? errors[val.apikey]
                              : ""}
                          </div>
                        </div>
                      );
                    }
                  })}
                  <div>
                    <button
                      type="submit"
                      className="bg-gray-800 mt-16  hover:opacity-80 
                      rounded-md font-medium px-5 py-2 text-white capitalize "
                    >
                      submit
                    </button>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
        <div
          className="absolute top-1 right-5 border border-gray-600  text-gray-600 bg-white  
        hover:bg-opacity-60  text-3xl rounded-full p-1 cursor-pointer "
          onClick={() => {
            setShowEditData(false);
          }}
        >
          <MdClose />
        </div>
      </div>
    </div>
  );

  return (
    <div className="m-5">
      <ToastContainer />
      <div
        className={`${
          showEditData === true
            ? "fixed bg-black bg-opacity-10   overflow-auto  z-50 top-0 bottom-0 right-0 left-0"
            : ""
        } `}
      >
        <div
          className={` ${
            showEditData ? "translate-y-0  " : "-translate-y-full  "
          }  duration-700 delay-300 ease-in-out   absolute top-0 bottom-0 right-0 left-0  z-40 `}
        >
          {showEditData ? mod : ""}{" "}
        </div>
      </div>
      <Table Head={Thead}>
        {tBody?.map((val, i) => {
          return (
            <tr className={` ${i !== tBody.length ? "border-b " : ""}`} key={i}>
              <td className="border-r border-l">
                <div className="mx-5  py-2.5">{i + 1}</div>
              </td>
              <td className="border-r">
                <div className="mx-3  capitalize">{val.title}</div>
              </td>
              <td className="border-r">
                <div className="mx-3  capitalize">{val.price}</div>
              </td>
              <td className="border-r">
                <div className="mx-3  capitalize">
                  {val.service?.map((vals, index) => {
                    return <div key={index}>{vals?.name}</div>;
                  })}
                </div>
              </td>
              <td className="border-r">
                <div className="mx-3  capitalize">{val.date}</div>
              </td>
              <td className="border-r">
                <div
                  className={`my-3  w-48 h-48  ml-10  flex justify-center items-center  `}
                >
                  <img
                    src={`${process.env.REACT_APP_API_URL}/public/${val.image}`}
                    alt="Loading..."
                    height={150}
                    width={150}
                    className="w-48 h-48"
                  />
                </div>
              </td>
              <td className="border-r">
                <div
                  className={` ${
                    val.status === "pending"
                      ? "text-yellow-400"
                      : val.status === "canceled"
                      ? "text-red-600"
                      : val.status === "accepted"
                      ? "text-green-500"
                      : val.status === "completed"
                      ? "text-gray-500"
                      : ""
                  } mx-3  capitalize font-medium`}
                >
                  {val.status}
                </div>
              </td>
              <td className="border-r">
                <div className="flex mx-3 gap-2 items-center justify-center">
                  {" "}
                  <div className="">
                    <button
                      className="border border-gray-600 rounded-md  hover:bg-blue-100 hover:text-blue-500 px-2 py-1"
                      onClick={() => Edit(val)}
                    >
                      <MdEdit className="text-2xl" />
                    </button>
                  </div>
                  <div className="">
                    <button
                      className=" capitalize border border-[#9a9a9a] px-2 py-1 rounded-md hover:bg-red-100  hover:text-red-500"
                      onClick={() => Conformation(val.id)}
                    >
                      <MdDelete className="text-2xl" />
                    </button>
                  </div>
                  {ConformationMessage}
                </div>
              </td>
            </tr>
          );
        })}
      </Table>
    </div>
  );
}

export default ViewBooking;
